// IMPORT MODULES
import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import $ from "jquery";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { Store } from 'react-notifications-component';

// ASSETS LOAD
import "./styles/css/linearicons.css";
import "./styles/css/magnific-popup.css";
import "./styles/css/nice-select.css";
import "./styles/css/animate.min.css";
import "./styles/css/owl.carousel.css";

// CUSTOM ASSETS LOAD
import "./styles/main.scss";
import "./design-system/design-system.css";
import "./styles/legacy-bootstrap-bridge.scss";

// COMPONENT LOAD
import Landing from "./components/layout/Landing";
import Register from "./components/auth/Register";
import Login from "./components/auth/Login";
import PrivateRoute from "./components/private-route/PrivateRoute";
import Dashboard from "./components/admin/Dashboard";
import ArticlesList from "./components/admin/ArticlesList";
import ArticleForm from "./components/admin/ArticleForm";
import ArticleDetailAdmin from "./components/admin/ArticleDetail";
import ProjectList from "./components/admin/ProjectList";
import ProjectForm from "./components/admin/ProjectForm";
import StageList from "./components/admin/StageList";
import StageForm from "./components/admin/StageForm";
import ProfessionalList from "./components/admin/ProfessionalList";
import ProfessionalForm from "./components/admin/ProfessionalForm";
import NewsletterList from "./components/admin/NewsletterList";
import NewsletterDetail from "./components/admin/NewsletterDetail";
import ContactsList from "./components/admin/ContactsList";
import ContactDetail from "./components/admin/ContactDetail";
import ContactSettings from "./components/admin/ContactSettings";
import UsersList from "./components/admin/UsersList";
import UserForm from "./components/admin/UserForm";
import UserProfile from "./components/admin/UserProfile";
import CVsList from "./components/admin/CVsList";
import AnalyticsPage from "./components/admin/AnalyticsPage";
import Home from "./components/page/Home";
import About from "./components/page/About";
import Portfolio from "./components/page/Portfolio";
import Contact from "./components/page/Contact";
import Tag from "./components/layout/Tag";
import Veille from "./components/page/Veille/Veille";
import ScrollTop from "./components/layout/ScrollTop";
import ScrollToTopOnNavigate from "./components/layout/ScrollToTopOnNavigate";
import VeilleArticles from "./components/page/Veille/VeilleArticles";
import Stage from "./components/page/Stage/Stage";
import StageArticles from "./components/page/Stage/StageArticles";
import PPE from "./components/page/PPE/PPE";
import PPEArticles from "./components/page/PPE/PPEArticles";
import NotFound from "./components/page/NotFound";
import PP from "./components/page/PP/PP";
import PPArticles from "./components/page/PP/PPArticles";
import ArticleList from "./components/page/Article/ArticleList";
import ArticleDetail from "./components/page/Article/ArticleDetail";
import ProjectsList from "./components/page/Project/ProjectsList";
import ProjectDetail from "./components/page/Project/ProjectDetail";
import ConfirmationModal from "./components/layout/ConfirmationModal";
import ToastHost from "./components/layout/ToastHost";
import AnalyticsTracker from "./components/layout/AnalyticsTracker";
import NewsletterUnsubscribe from "./components/page/NewsletterUnsubscribe";

// Monkey-patch Store.addNotification au boot pour rediriger toutes les
// notifications vers le ToastHost stylé Bold Duotone. Les 26 call sites
// existants continuent d'appeler Store.addNotification sans modification.
Store.addNotification = (opts = {}) => {
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('ds-toast', { detail: opts }));
    }
    return Date.now();
};
Store.removeNotification = () => {};

// INITIALIZE GLOBAL
window.resetScript = () => {
    $(document).ready((e) => {
        $('.main-script').html(`<script src="${process.env.PUBLIC_URL}/externals/main.js"></script>`);
        $('.superfish-script').html(`<script src="${process.env.PUBLIC_URL}/externals/superfish.min.js"></script>`);
        $('.owl-carousel-script').html(`<script src="${process.env.PUBLIC_URL}/externals/owl.carousel.min.js"></script>`);
    })
};

class App extends Component {
    render() {
        return (
            <Router>
                <div className={`App ${this.props._preferences._dark ? 'AppDark' : ''}`}>
                    <ToastHost />
                    <ConfirmationModal />
                    <AnalyticsTracker />
                    <ScrollToTopOnNavigate />

                    <Switch>
                        <Route exact path="/" component={() => <Home />} />
                        <Route exact path="/about" component={() => <About />} />
                        <Route exact path="/portfolio" component={() => <Portfolio />} />

                        <Route exact path="/contact" component={() => <Contact />} />
                        <Route exact path="/newsletter/unsubscribe" component={() => <NewsletterUnsubscribe />} />
                        <Route exact path="/tag" component={() => <Tag />} />

                        <Route exact path="/veille" component={() => <Veille />} />
                        <Route exact path="/veille/juridique" component={() => <VeilleArticles type="VEILLE_JURIDIQUE" />} />
                        <Route exact path="/veille/technologie" component={() => <VeilleArticles type="VEILLE_TECHNOLOGIQUE" />} />

                        <Route exact path="/stage" component={() => <StageArticles />} />
                        {['/stage/:session'].map(_path => <Route key={_path} exact path={_path} component={() => <Stage />} />)}

                        <Route exact path="/ppe" component={() => <PPEArticles />} />
                        {['/ppe/:session'].map(_path => <Route key={_path} exact path={_path} component={() => <PPE />} />)}

                        <Route exact path="/pp" component={() => <PPArticles />} />
                        {['/pp/:session'].map(_path => <Route key={_path} exact path={_path} component={() => <PP />} />)}

                        <Route exact path="/article" component={() => <ArticleList />} />
                        <Route exact path="/article/:slug" component={() => <ArticleDetail />} />

                        <Route exact path="/projets" component={() => <ProjectsList />} />
                        <Route exact path="/projets/:slug" component={ProjectDetail} />

                        <PrivateRoute exact path="/landing" component={Landing} />
                        <Route exact path="/login" component={Login} />

                        <PrivateRoute exact path="/dashboard" component={Dashboard} />
                        <PrivateRoute exact path="/dashboard/articles" component={ArticlesList} />
                        <PrivateRoute exact path="/dashboard/articles/new" component={ArticleForm} />
                        <PrivateRoute exact path="/dashboard/articles/:id/view" component={ArticleDetailAdmin} />
                        <PrivateRoute exact path="/dashboard/articles/:id" component={ArticleForm} />

                        <PrivateRoute exact path="/dashboard/projects" component={ProjectList} />
                        <PrivateRoute exact path="/dashboard/projects/new" component={ProjectForm} />
                        <PrivateRoute exact path="/dashboard/projects/:id" component={ProjectForm} />

                        <PrivateRoute exact path="/dashboard/stages" component={StageList} />
                        <PrivateRoute exact path="/dashboard/stages/new" component={StageForm} />
                        <PrivateRoute exact path="/dashboard/stages/:id" component={StageForm} />

                        <PrivateRoute exact path="/dashboard/professionals" component={ProfessionalList} />
                        <PrivateRoute exact path="/dashboard/professionals/new" component={ProfessionalForm} />
                        <PrivateRoute exact path="/dashboard/professionals/:id" component={ProfessionalForm} />

                        <PrivateRoute exact path="/dashboard/newsletter" component={NewsletterList} />
                        <PrivateRoute exact path="/dashboard/newsletter/:id" component={NewsletterDetail} />

                        <PrivateRoute exact path="/dashboard/contacts" component={ContactsList} />
                        <PrivateRoute exact path="/dashboard/contacts/:id" component={ContactDetail} />
                        <PrivateRoute exact path="/dashboard/contacts/settings" component={ContactSettings} />

                        <PrivateRoute exact path="/dashboard/users" component={UsersList} />
                        <PrivateRoute exact path="/dashboard/users/new" component={UserForm} />
                        <PrivateRoute exact path="/dashboard/users/:id" component={UserForm} />
                        <PrivateRoute exact path="/dashboard/profile" component={UserProfile} />

                        <PrivateRoute exact path="/dashboard/cvs" component={CVsList} />
                        <PrivateRoute exact path="/dashboard/analytics" component={AnalyticsPage} />

                        <Route exact render={() => <NotFound />} />
                    </Switch>

                    <ScrollTop />
                </div>
            </Router>
        );
    }
}

App.protoType = {
    _preferences: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    _preferences: state._preferences
});

export default connect(
    mapStateToProps,
    {}
)(App);
